var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChromeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31 31 40 20 40C9 40 0 31 0 20C0 9 9 0 20 0C31 0 40 9 40 20Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 0V20L28.0002 24L19.2002 40C19.5002 40 19.7002 40 20.0002 40C31.1002 40 40.0002 31.1 40.0002 20C40.0002 8.9 31.1002 0 20.0002 0Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31 31 40 20 40C9 40 0 31 0 20C0 9 9 0 20 0C31 0 40 9 40 20Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 0V20L28.0002 24L19.2002 40C19.5002 40 19.7002 40 20.0002 40C31.1002 40 40.0002 31.1 40.0002 20C40.0002 8.9 31.1002 0 20.0002 0Z",
    fill: "#FFC107"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8002 11H20.0002V24L17.0002 23L3.2002 9.3C6.7002 3.7 12.9002 0 20.0002 0C27.8002 0 34.5002 4.5 37.8002 11Z",
    fill: "#F44336"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 20C29 25 25 29 20 29C15 29 11 25 11 20C11 15 15 11 20 11C25 11 29 15 29 20Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20C27 23.9 23.9 27 20 27C16.1 27 13 23.9 13 20C13 16.1 16.1 13 20 13C23.9 13 27 16.1 27 20Z",
    fill: "#2196F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeLogo);
export default __webpack_public_path__ + "static/media/chrome-logo.54c61c97ef5aa61118d24011894d5dda.svg";
export { ForwardRef as ReactComponent };